import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityAuditTrailExportSlice } from './post';

export const coreDataSecurityAuditTrailExportReducers = combineReducers({
	post: postCoreDataSecurityAuditTrailExportSlice.asyncReducers
});

export const coreDataSecurityAuditTrailExportWatchers = combineAllWatchers([
	postCoreDataSecurityAuditTrailExportSlice.asyncWatchers
]);
